
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect, AppFileUpload, AppButton, AppDateTimePicker } from '@/components';
import { useLiveopsAdd } from '@/modules/liveops/item/model/add';
import { LiveopsOptions, LiveopsRewardType } from '@/modules/liveops/item/types';
import MilestoneTable from '@/modules/liveops/milestone/view/table.vue';
import LeaderboardTable from '@/modules/liveops/leaderboard/view/table.vue';

export default defineComponent({
    name: 'LiveopsAdd',
    components: {
        AppFormRow,
        AppInput,
        AppSelect,
        AppFileUpload,
        AppCard,
        AppButton,
        AppDateTimePicker,
        MilestoneTable,
        LeaderboardTable
    },
    setup() {
        const { model, v$, actions } = useLiveopsAdd();

        return { model, v$, actions, LiveopsOptions, LiveopsRewardType };
    }
});
